module.exports = __webpack_public_path__ + "static/media/1 2 '99_62528fb4-6ed0-40b2-af1b-599071ac29cb.eaf63a56.png";